import React from 'react';
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Divider,
} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import DevicesIcon from '@mui/icons-material/Devices';
import GroupIcon from '@mui/icons-material/Group';
import PlaceIcon from '@mui/icons-material/Place';
import NotificationsIcon from '@mui/icons-material/Notifications';
import EventIcon from '@mui/icons-material/Event';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import BarChartIcon from '@mui/icons-material/BarChart';
import StorageIcon from '@mui/icons-material/Storage';
import PeopleIcon from '@mui/icons-material/People';
import ComputerIcon from '@mui/icons-material/Computer';
import SettingsIcon from '@mui/icons-material/Settings';

const SettingsMenu = ({ selectedSection, onSectionChange }) => {
  const settingsCategories = [
    {
      title: 'Usuario',
      items: [
        { id: 'user', icon: <PersonIcon />, label: 'Usuario' },
        { id: 'preferences', icon: <SettingsIcon />, label: 'Preferencias' },
      ],
    },
    {
      title: 'Dispositivos',
      items: [
        { id: 'devices', icon: <DevicesIcon />, label: 'Dispositivos' },
        { id: 'groups', icon: <GroupIcon />, label: 'Grupos' },
        { id: 'drivers', icon: <DirectionsCarIcon />, label: 'Conductores' },
      ],
    },
    {
      title: 'Notificaciones',
      items: [
        { id: 'geofences', icon: <PlaceIcon />, label: 'Geocercas' },
        { id: 'notifications', icon: <NotificationsIcon />, label: 'Notificaciones' },
        { id: 'calendars', icon: <EventIcon />, label: 'Calendarios' },
      ],
    },
    {
      title: 'Administración',
      items: [
        { id: 'users', icon: <PeopleIcon />, label: 'Usuarios' },
        { id: 'server', icon: <ComputerIcon />, label: 'Servidor' },
        { id: 'statistics', icon: <BarChartIcon />, label: 'Estadísticas' },
        { id: 'attributes', icon: <StorageIcon />, label: 'Atributos' },
      ],
    },
  ];

  return (
    <Box sx={{ overflow: 'auto', flex: 1 }}>
      {settingsCategories.map((category, idx) => (
        <Box key={idx}>
          <Typography
            variant="overline"
            sx={{
              px: 2,
              py: 1.5,
              display: 'block',
              color: '#757575',
              fontSize: '0.75rem',
              fontWeight: 600,
              letterSpacing: '0.5px',
            }}
          >
            {category.title}
          </Typography>
          <List sx={{ py: 0 }}>
            {category.items.map((item) => (
              <ListItemButton
                key={item.id}
                selected={selectedSection === item.id}
                onClick={() => onSectionChange(item.id)}
                sx={{
                  py: 1.25,
                  px: 2,
                  '&.Mui-selected': {
                    bgcolor: '#e3f2fd',
                    borderLeft: '3px solid #1976d2',
                    '&:hover': {
                      bgcolor: '#e3f2fd',
                    },
                  },
                  '&:hover': {
                    bgcolor: '#f5f5f5',
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 40,
                    color: selectedSection === item.id ? '#1976d2' : '#616161',
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontSize: '0.875rem',
                    fontWeight: selectedSection === item.id ? 600 : 500,
                    color: selectedSection === item.id ? '#1976d2' : 'inherit',
                  }}
                />
              </ListItemButton>
            ))}
          </List>
          {idx < settingsCategories.length - 1 && <Divider sx={{ my: 1 }} />}
        </Box>
      ))}
    </Box>
  );
};

export default SettingsMenu;